<div id="update-ready" *ngIf="updateReady" (click)="updateReady = false" [@updateVisibilityAnimation]>
  CurbNTurf has been updated please refresh
  <span> X </span>
</div>
